import React, { Component } from 'react'

export default class Healthy extends Component {
  render() {
    return (
      <>
        <div className="heathy text-white py-5">
            <div className="container py-5 text-center">
            <h2 className="fw-bold mb-5">HEALTHY MIND, HEALTHY BODY </h2>
            <p className="w-75 m-auto mb-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum 
            </p>
            <button className="btn border text-white px-4 p-2">READ MORE</button>
            </div>
        </div>       
      </>
    )
  }
}
